import React from 'react';
import { PaywallCard } from './PaywallCard';
import { Typography, Divider } from '@mui/material';

const features = [
  'Unlimited projects',
  'External collaborators (guests)',
  'API + automated exports',
  'Custom exports',
  'Onboarding workshop',
  'Dedicated support',
];

export const EnterprisePlan = () => {
  return (
    <PaywallCard>
      <PaywallCard.Header
        title="Enterprise"
        subheader="For portfolio-wide use, integrations, and external collaborators."
      />
      <PaywallCard.Price>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 400,
            color: 'text.secondary',
          }}
        >
          Custom
        </Typography>
      </PaywallCard.Price>
      <Divider />
      <PaywallCard.Submit
        color="inherit"
        plan="enterprise"
        text="Contact sales"
      />
      <PaywallCard.Features
        header="All features in Pro, plus"
        features={features}
      />
    </PaywallCard>
  );
};
